<template>
    <!-- <div class="type_selector" v-if="type == 0">
        <h5>实名类型</h5>
        <div class="auth_types">
            <div :class="{active: activeIndex2 == 1}" @click="activeIndex2 = 1">
                <span>个人实名</span>
            </div>
            <div :class="{active: activeIndex2 == 2}" @click="activeIndex2 = 2">
                <span>企业实名</span>
            </div>
            <footer>
                <el-button type="primary" class="btn" @click="type = activeIndex2; activeIndex = activeIndex2 == 1 ? 1 : 4">下一步</el-button>
            </footer>
        </div>
    </div> -->

    <div class="type_selector" v-if="userInfo.type == 1">
        <h5>个人实名</h5>
        <div class="auth_types">
            <div :class="{active: activeIndex == 1}" @click="activeIndex = 1">
                <iconpark-icon name="zhifubaozhifu"></iconpark-icon>
                <span>支付宝实名认证</span>
            </div>

            <!-- <div :class="{active: activeIndex == 2}" @click="activeIndex = 2">
                <iconpark-icon name="weixin"></iconpark-icon>
                <span>微信实名认证</span>
            </div> -->

            <div :class="{active: activeIndex == 3}" @click="activeIndex = 3">
                <iconpark-icon name="shimingrenzheng"></iconpark-icon>
                <span>填写资料实名认证</span>
            </div>

            <footer>
                <!-- <el-button class="btn" @click="type = 0">上一步</el-button> -->
                <!-- <el-button type="primary" class="btn" @click="toAuth">下一步</el-button> -->
                 <span class="auth-btn" @click="toAuth">下一步</span>
            </footer>
        </div>
    </div>
    <div class="type_selector" v-if="userInfo.type == 2">
        <h5>企业实名</h5>
        <div class="auth_types">
            <div :class="{active: activeIndex == 4}" @click="activeIndex = 4">
                <iconpark-icon name="faren"></iconpark-icon>
                <span>法人代表工商认证</span>
            </div>
            <!-- <div :class="{active: activeIndex == 5}" @click="activeIndex = 5">
                <iconpark-icon name="shoukuan"></iconpark-icon>
                <span>企业账户小额收款认证</span>
            </div>
            <div :class="{active: activeIndex == 6}" @click="activeIndex = 6">
                <iconpark-icon name="dakuandengji"></iconpark-icon>
                <span>企业账户小额打款认证</span>
            </div> -->

            <footer>
                <!-- <el-button class="btn" @click="type = 0">上一步</el-button> -->
                <!-- <el-button type="primary" class="btn" @click="toAuth">下一步</el-button> -->
                 <span class="auth-btn" @click="toAuth">下一步</span>
            </footer>
        </div>
    </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue';
import { useStore } from 'vuex';
const store = useStore()
const userInfo = computed(() => {
    return store.state.login.userInfo
})
const activeIndex = ref(1)
const activeIndex2 = ref(1)
const type = ref(0)
const emit = defineEmits(['next'])
const toAuth = () => {
    emit('next', activeIndex.value)
}

</script>

<style scoped lang="scss">
.auth-btn {
    width: 488rem;
    height: 40rem;
    background: #000;
    border: 1px solid #000;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    &.limit {
        width: 390rem;
    }
    &.plain {
        background-color: #fff;
        color: rgba(114, 111, 249, 1);
    }
    &.block {
        width: 500rem;
        margin: 0 auto;
    }
}
.type_selector{
    width: 100%; margin-top: 50rem; height: 580rem; background-color: #fff; display: flex; flex-direction: column; align-items: center;  border-radius: 10rem; overflow: hidden;
    h5{
        width: 100%; height: 70rem; line-height: 70rem; text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(56, 56, 56, 1);
        border-bottom: 1px solid rgba(242, 242, 242, 1);
    }
    .auth_types{
        width: 100%; height: calc(100% - 70rem); padding: 0 20rem 70rem 20rem; display: flex; flex-direction: column; align-items: center; justify-content: center; position: relative;
        >div{
            width: 100%; height: 60rem; display: flex; align-items: center; justify-content: center; border: 1rem solid #A6A6A6;  color: #A6A6A6;
            margin: 15rem 0; cursor: pointer;
            iconpark-icon{font-size: 20rem; margin-right: 10rem;}
        }
        footer{
            width: calc(100% - 150rem); position: absolute; bottom: 30rem; display: flex; justify-content: center;
            .btn{height: 40rem; width: 100%; }
        }
        .active{
            border-color: rgba(114, 111, 249, 1); color: rgba(114, 111, 249, 1);
        }
    }
}
</style>